<template>
  <div class="zzvideo">
    <bs-detail
      :filter="filter"
      :meta="{ module:'single-article', field:'zzzg' }"
    >
      <template slot="data">
        <div class="mobile-videoplay-img" style="padding-top: 20px;padding-bottom: 20px">
          <img src="../../assets/mobile/zhuzimap.png" style="width: 100%;height: 100%;" />
        </div>
        <div class="mobile-zhuzimap-container">
          <div class="mobile-zhuzimap">
              文化地图是反映制图区域文化、教育、科研、医疗、卫生事业和娱乐部门发展状况、构成和分布的地图，反映一个制图区域公众文化水平状况和文化事业发展水平，是一种专题地图。挖掘制图区域的历史底蕴，精准把握地域文化特征，运用地域民间色彩语言和图案语言元素，创新地图设计思维，提升地图设计理念，以直观的地图语言，结合各种图表、照片和文字说明，科学、准确、权威、系统地反映不同历史时期不同的地域文化特征，形象、生动、直观地表达历史文化遗产。
          </div>
        </div>
      </template>
    </bs-detail>
  </div>
</template>
<script>
require("../../styles/mobile/mobile-arti-detail-video.scss");
export default {
  data() {
    return {
      routeType: "arti",
      filter: {
        artiId: 'f4f2dbe5-a9b0-410c-b72b-f4cfa753d384'
      },
    };
  },
  mounted() {},
  methods: {
    handleGoBack() {
      window.history.back();
    }
  },
  components: {
    BsDetail: () => import("../../components/bs-detail"),
  },
  computed: {
    currentModule() {
      return `${this.$route.params._module}_${this.$route.params._field}`;
    }
  },
  watch: {
    $route: function(to, from) {
      let contain =
        to.name.indexOf(`mobile-${this.routeType}-detail`) !== -1 ||
        from.name.indexOf(`mobile-${this.routeType}-detail`) !== -1;
      if (this.routeWatch && contain && this.$route.params._artiId) {
        this.$refs["refId"].cleaeData();
        this.meta.module = this.$route.params._module;
        this.meta.field = this.$route.params._field;
        this.filter.artiId = this.$route.params._artiId;
        this.$refs["refId"].loadData();
      }
    }
  }
};
</script>
<style>
.m-mobile-arti-detail{
    padding-bottom: 100px;
}
.mobile-zhuzimap-container{
    margin: 0 15px;
}
.mobile-zhuzimap{
    font-size: 11px;
    font-family: SourceHanSansCN-Normal;
    font-weight: 400;
    color: #666666;
    line-height: 35px;
    text-indent: 2em;
}
</style>
